const DeviceDataOverrideService = {
    dataTypeTokenDataOverrides: {},

    getOverrideFunctionForDeviceTypeToken: (token) => {
        if (DeviceDataOverrideService.dataTypeTokenDataOverrides && DeviceDataOverrideService.dataTypeTokenDataOverrides[token]) {
            if ("f_to_c" === DeviceDataOverrideService.dataTypeTokenDataOverrides[token]) {
                return (amount) => {
                    return amount == null ? null : Math.round((amount - 32.0) * (5 / 9) * 100) / 100;
                };
            }
        }

        return (amount) => {
            return amount;
        };
    },

    getReverseOverrideFunctionForDeviceTypeToken: (token) => {
        if (DeviceDataOverrideService.dataTypeTokenDataOverrides && DeviceDataOverrideService.dataTypeTokenDataOverrides[token]) {
            if ("f_to_c" === DeviceDataOverrideService.dataTypeTokenDataOverrides[token]) {
                return (amount) => {
                    return amount == null ? null : Math.round(((amount * 9/5) + 32) * 100) / 100;
                };
            }
        }

        return (amount) => {
            return amount;
        };
    },

    dataTypeTokenTokenOverrides: {},

    getOverrideForDisplayToken: (token) => {
        if (token && DeviceDataOverrideService.dataTypeTokenTokenOverrides && DeviceDataOverrideService.dataTypeTokenTokenOverrides[token]) {
            return DeviceDataOverrideService.dataTypeTokenTokenOverrides[token];
        } else {
            return token;
        }
    },

    displayFormatOverrides: {},

    getOverrideForDisplayFormat: (format) => {
        if (format && DeviceDataOverrideService.displayFormatOverrides && DeviceDataOverrideService.displayFormatOverrides[format]) {
            return DeviceDataOverrideService.displayFormatOverrides[format];
        } else {
            return format;
        }
    },
};

export default DeviceDataOverrideService;